import { ATLAS_AUTH_INFO_LOCAL_STORAGE_KEY } from "@/modules/atlas-auth/constants";
import localforage from "localforage";

export const clearCurrentAtlasAuthInfo = async (): Promise<void> => {
  await localforage.removeItem(ATLAS_AUTH_INFO_LOCAL_STORAGE_KEY);
};
